import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";

function List(props: ListProps) {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{ page: 1, perPage: 10, search: null }}
        path={`${props.path}/classificacoes-de-eventos`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.EventClassifications.items}
        formatPagination={(data) => data.EventClassifications.paginationInfo}
        title="NOVA CLASSIFICAÇÃO DE EVENTO"
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`${props.path}/classificacoes-de-eventos/${value}`} value={value} />
            ),
          },
          {
            Header: "Nome",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
